export default __webpack_public_path__ + "static/media/logout.cde423e6.svg";